import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { PermissionService } from 'src/app/auth/services/permission.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListItem, ListOperation } from '../scrolling-list';

@Component({
  selector: 'operations-menu',
  templateUrl: './operations-menu.component.html',
  styleUrls: ['./operations-menu.component.scss'],
  imports: [
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    NgClass,
    SharedModule,
  ],
})
export class OperationsMenuComponent<T extends { folderId?: string }> {
  private permissionService = inject(PermissionService);

  @Input() operations: ListOperation<T>[] = [];
  @Input() entityId?: string;
  @Input() listItem?: ListItem<T>;
  @Input() id: string;

  @Output() operationClick = new EventEmitter<string>();

  @ViewChild('matMenuTrigger') matMenuTrigger: MatMenuTrigger;

  protected handleClick(operationName: string) {
    this.operationClick.emit(operationName);
  }

  protected get singleActions() {
    return this.operations
      .filter((operation) => operation.showIn?.includes('single'))
      .filter((operation) =>
        this.permissionService.meetsAccessRequirement({
          ...operation,
          entityId: this.entityId,
        }),
      )
      .filter(
        (operation) =>
          !(
            operation.hidden &&
            operation.hidden(this.listItem ? [this.listItem] : undefined)
          ),
      );
  }
}
